import { hasKey } from 'helpers/typescript'

const env = process.env.REACT_APP_ENV ?? 'development'

export const enableTsBilling = true // env !== 'production'

// Anywhere but production a claim stops at Optum's validation; see OptumApiService.
export const claimsReachPayers = env === 'production'

// QuickSight embeds point at production data, so they stay hidden on the dev deployment.
// DME only — lab analytics is gated by the VIEW_ANALYTICS permission instead (TES-2981).
export const enableAnalytics = env !== 'development'

export const specialClients = {
  local: {
    5: 'adapt',
  },
  development: {
    5: 'adapt',
  },
  production: {
    51: 'adapt',
  },
}[env]

const config = {
  // Local
  local: {
    auth0: {
      authRedirectUri:
        process.env.REACT_APP_AUTH0_AUTH_REDIRECT_URI ?? 'http://localhost:5001/login/callback',
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '290aJGGivqugc8biewl9tAqJYuunPdSz',
      domain: process.env.REACT_APP_AUTH0_DOMAIN ?? 'auth-dev.testsmarter.net',
    },
    newApi: process.env.REACT_APP_NEW_API_URL ?? 'http://localhost:3001',
    sentryDsn:
      process.env.REACT_APP_SENTRY_DSN ??
      'https://3abef1a34ce6d69bb7e9a6f96f65211b@o473585.ingest.sentry.io/4506380507414528',
    ws: 'ws://localhost:1112',
    googleApiKey: process.env.REACT_APP_GOOGLE_API ?? 'AIzaSyArQqFGNER9G_D13S5croNiKemM6F8v3OE',
    testSmarterFaxNumber: process.env.REACT_APP_TS_FAX_NUMBER ?? '(386) 382-4201',
    stripeCustomerUrl:
      process.env.REACT_APP_STRIPE_CUSTOMER_URL ?? 'https://dashboard.stripe.com/test/customers/',
    // QuickSight dashboard id for the Billing Analytics embed. Unset by default: the value
    // changes when the analysis is repointed from the dev database to the production read
    // replica, and must not require a front-end code change to update.
    billingAnalyticsDashboardId: process.env.REACT_APP_BILLING_ANALYTICS_DASHBOARD_ID ?? 'billing-analytics',
    aws: {
      assetsBucket: process.env.REACT_AWS_S3_ASSETS_BUCKET ?? 'ts-platform-web-assets-dev',
      documentTemplatesFolder: process.env.REACT_AWS_S3_DOCUMENT_TEMPLATES_FOLDER ?? 'document-templates',
      cleaningInstructionsFolder:
        process.env.REACT_AWS_S3_CLEANING_INSTRUCTIONS_FOLDER ?? 'cleaning-instructions',
    },
  },

  // Development
  development: {
    auth0: {
      authRedirectUri:
        process.env.REACT_APP_AUTH0_AUTH_REDIRECT_URI ?? `${window.location.origin}/login/callback`,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '290aJGGivqugc8biewl9tAqJYuunPdSz',
      domain: process.env.REACT_APP_AUTH0_DOMAIN ?? 'auth-dev.testsmarter.net',
    },
    newApi: process.env.REACT_APP_NEW_API_URL ?? 'https://api.dev.testsmarter.com',
    sentryDsn:
      process.env.REACT_APP_SENTRY_DSN ??
      'https://3abef1a34ce6d69bb7e9a6f96f65211b@o473585.ingest.sentry.io/4506380507414528',
    ws: 'ws://localhost:1112',
    googleApiKey: process.env.REACT_APP_GOOGLE_API ?? 'AIzaSyArQqFGNER9G_D13S5croNiKemM6F8v3OE',
    testSmarterFaxNumber: process.env.REACT_APP_TS_FAX_NUMBER ?? '(386) 382-4201',
    stripeCustomerUrl:
      process.env.REACT_APP_STRIPE_CUSTOMER_URL ?? 'https://dashboard.stripe.com/test/customers/',
    // QuickSight dashboard id for the Billing Analytics embed. Unset by default: the value
    // changes when the analysis is repointed from the dev database to the production read
    // replica, and must not require a front-end code change to update.
    billingAnalyticsDashboardId: process.env.REACT_APP_BILLING_ANALYTICS_DASHBOARD_ID ?? 'billing-analytics',
    aws: {
      assetsBucket: process.env.REACT_AWS_S3_ASSETS_BUCKET ?? 'ts-platform-web-assets-dev',
      documentTemplatesFolder: process.env.REACT_AWS_S3_DOCUMENT_TEMPLATES_FOLDER ?? 'document-templates',
      cleaningInstructionsFolder:
        process.env.REACT_AWS_S3_CLEANING_INSTRUCTIONS_FOLDER ?? 'cleaning-instructions',
    },
  },

  // Testing
  staging: {
    auth0: {
      authRedirectUri:
        process.env.REACT_APP_AUTH0_AUTH_REDIRECT_URI ?? `${window.location.origin}/login/callback`,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? 'mR2lDGGqVtFKFUlMFQugDlgZKzLEVfjz',
      domain: process.env.REACT_APP_AUTH0_DOMAIN ?? 'auth-staging.testsmarter.net',
    },
    newApi: process.env.REACT_APP_NEW_API_URL ?? 'https://api-staging.testsmarter.net',
    sentryDsn:
      process.env.REACT_APP_SENTRY_DSN ??
      'https://3abef1a34ce6d69bb7e9a6f96f65211b@o473585.ingest.sentry.io/4506380507414528',
    ws: 'ws://localhost:1112',
    googleApiKey: process.env.REACT_APP_GOOGLE_API ?? 'AIzaSyArQqFGNER9G_D13S5croNiKemM6F8v3OE',
    testSmarterFaxNumber: process.env.REACT_APP_TS_FAX_NUMBER ?? '(386) 382-4201',
    stripeCustomerUrl:
      process.env.REACT_APP_STRIPE_CUSTOMER_URL ?? 'https://dashboard.stripe.com/test/customers/',
    // QuickSight dashboard id for the Billing Analytics embed. Unset by default: the value
    // changes when the analysis is repointed from the dev database to the production read
    // replica, and must not require a front-end code change to update.
    billingAnalyticsDashboardId: process.env.REACT_APP_BILLING_ANALYTICS_DASHBOARD_ID ?? 'billing-analytics',
    aws: {
      assetsBucket: process.env.REACT_AWS_S3_ASSETS_BUCKET ?? 'ts-platform-web-assets-dev',
      documentTemplatesFolder: process.env.REACT_AWS_S3_DOCUMENT_TEMPLATES_FOLDER ?? 'document-templates',
      cleaningInstructionsFolder:
        process.env.REACT_AWS_S3_CLEANING_INSTRUCTIONS_FOLDER ?? 'cleaning-instructions',
    },
  },

  // Production
  production: {
    auth0: {
      authRedirectUri:
        process.env.REACT_APP_AUTH0_AUTH_REDIRECT_URI ?? `${window.location.origin}/login/callback`,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? 'sDgDQuyW9BKkpC7JgRTjOSZ6KS1r2o7C',
      domain: process.env.REACT_APP_AUTH0_DOMAIN ?? 'auth.testsmarter.net',
    },
    newApi: process.env.REACT_APP_NEW_API_URL ?? 'https://api-prod.testsmarter.net',
    sentryDsn:
      process.env.REACT_APP_SENTRY_DSN ??
      'https://96e107afbaaa3c1542a3c998c05672b6@o473585.ingest.sentry.io/4506378692263936',
    ws: 'ws://localhost:1112',
    googleApiKey: process.env.REACT_APP_GOOGLE_API ?? 'AIzaSyArQqFGNER9G_D13S5croNiKemM6F8v3OE',
    testSmarterFaxNumber: process.env.REACT_APP_TS_FAX_NUMBER ?? '(386) 382-4201',
    stripeCustomerUrl:
      process.env.REACT_APP_STRIPE_CUSTOMER_URL ?? 'https://dashboard.stripe.com/test/customers/',
    // QuickSight dashboard id for the Billing Analytics embed. Unset by default: the value
    // changes when the analysis is repointed from the dev database to the production read
    // replica, and must not require a front-end code change to update.
    billingAnalyticsDashboardId: process.env.REACT_APP_BILLING_ANALYTICS_DASHBOARD_ID ?? 'billing-analytics',
    aws: {
      assetsBucket: process.env.REACT_AWS_S3_ASSETS_BUCKET ?? 'ts-platform-web-assets',
      documentTemplatesFolder: process.env.REACT_AWS_S3_DOCUMENT_TEMPLATES_FOLDER ?? 'document-templates',
      cleaningInstructionsFolder:
        process.env.REACT_AWS_S3_CLEANING_INSTRUCTIONS_FOLDER ?? 'cleaning-instructions',
    },
  },
}

export default (() => {
  if (hasKey(config, env)) {
    return config[env]
  }
})()
